import React, {
  useState,
  useEffect,
} from 'react';
import {
  RouteProps,
  useDispatch,
} from 'react-redux';

import {
  coreActions,
} from '@gymcloud/core';

import {
  Icon,
  Avatar,
  Tooltip,
  Pagination,
} from 'web-components';
import {
  Flex,
  icons,
} from 'web-styled';
import {
  decodeParam,
} from 'web-utils';

import * as S from './styled';

const tabs = ['Individuals', 'Groups'];

interface Props {
  assignees: any[]
  routeProps: RouteProps
  clientsMeta: any
  openedTooltips?: string[]
  onAssignClient?: { (): void }
  onUnAssignClient?: { (): void }
  onAssignGroup?: { (): void }
  onUnAssignGroup?: { (): void }
}

const Assign = ({
  assignees,
  routeProps,
  clientsMeta,
  onAssignClient,
  onUnAssignClient,
  onAssignGroup,
  onUnAssignGroup,
  openedTooltips,
}: Props) => {
  const dispatch = useDispatch();
  const [tab, setTab] = useState(tabs[0]);
  const isGroup = tab === 'Groups';
  const items = isGroup ? assignees.groups : assignees.individuals;

  const params = decodeParam(routeProps.location.search);
  useEffect(() => {
    dispatch(
      coreActions.requestFetchClients({
        qs: {
          page: params.clientPage || '1',
          type: 'client',
          per_page: 50,
        },
        list: 'clientList',
        requestKey: 'fetchIndividuals',
        resourceType: 'clients',
      }),
    );
  }, [params.clientPage]);

  return (
    <Flex
      column
      width="100%"
      margin="15px 0 0 0"
    >
      <Flex
        width="100%"
        align="center"
        justify="space-between"
        padding="15px"
      >
        <S.Title>{tab}</S.Title>
        <Flex spacing={20}>
          {tabs.map(t => (
            <S.TabLink
              key={t}
              active={t === tab}
              onClick={() => setTab(t)}
            >
              {t}
            </S.TabLink>
          ))}
        </Flex>
      </Flex>
      <Flex
        column
        width="100%"
      >
        {items.map((item, i) => (
          <S.Item
            key={item.id}
            onClick={() => {
              let callback;
              if (item.is_assigned) {
                callback = isGroup ? onUnAssignGroup : onUnAssignClient;
              } else {
                callback = isGroup ? onAssignGroup : onAssignClient;
              }
              callback(item);
            }}
          >
            <Flex
              align="center"
              spacing={15}
            >
              <Avatar
                width="25px"
                height="25px"
                src={item.avatar || (isGroup ? icons.clientsGroupAvatar : null)}
                bgColor={isGroup ? 'transparent' : item.color}
                placeholderSize={13}
              />

              {!isGroup && i === 0 && openedTooltips.includes('choose client') ? (
                <Tooltip
                  body="Click a client to assign them a workout."
                  preferPlace="right"
                  toggleMode
                  initialState
                >
                  <S.Name>
                    {item.name}
                  </S.Name>
                </Tooltip>
              ) : (
                <S.Name>
                  {item.name}
                </S.Name>
              )}
            </Flex>
            {item.is_assigned && (
              <Flex
                spacing={5}
                align="center"
              >
                <Icon
                  type="fas fa-check"
                />
                {isGroup && (
                  <div>
                    {`${item.clients_count} of ${item.assigned_count}`}
                  </div>
                )}
              </Flex>
            )}
          </S.Item>
        ))}
      </Flex>

      {!isGroup && clientsMeta?.total_pages && clientsMeta?.total_pages > 1 && (
        <Flex padding="10px 0" justify="center" width="100%">
          <Pagination
            count={clientsMeta.total_pages}
            current={clientsMeta.page}
            goToPage={(p: number) => {
              routeProps.history.push({
                pathname: routeProps.match.url,
                search: `?clientPage=${p}`,
              });
            }}
          />
        </Flex>
      )}
    </Flex>
  );
};

Assign.defaultProps = {
  onAssignClient: () => {},
  onUnAssignClient: () => {},
  onAssignGroup: () => {},
  onUnAssignGroup: () => {},
  openedTooltips: [],
};

export default Assign;
